import { NgModule } from '@angular/core';
import { CommunityServiceCategoryListComponent }
  from './community-service-category/community-service-category-list/community-service-category-list.component';
import { SharedModule } from '../shared/shared.module';
import { CommunityServiceCategoryEditComponent }
  from './community-service-category/community-service-category-edit/community-service-category-edit.component';
import { CommunityProviderProgramEditComponent }
  from './community-provider-program/community-provider-program-edit/community-provider-program-edit.component';
import { CommunityProviderProgramListService }
  from '../core/service/grid-data/grid-data-community-provider-program.service';
import { CommunityProviderProgramListComponent }
  from './community-provider-program/community-provider-program-list/community-provider-program-list.component';
import { CommunityProviderProgramImportComponent }
  from './community-provider-program/community-provider-program-import/community-provider-program-import.component';
import { CommunityServiceSearchComponent } from './community-service-search/community-service-search.component';
import { CommunitySearchModule } from '../shared/community-search/community-search.module';
import { AddressValidatorModule } from '../shared/address-validator/address-validator.module';

@NgModule({
  imports: [
    SharedModule,
    CommunitySearchModule,
    AddressValidatorModule
  ],
  declarations: [
    CommunityServiceCategoryListComponent,
    CommunityServiceCategoryEditComponent,
    CommunityProviderProgramListComponent,
    CommunityProviderProgramEditComponent,
    CommunityProviderProgramImportComponent,
    CommunityServiceSearchComponent
  ],
  providers: [
    CommunityProviderProgramListService
  ]
})
export class CommunityModule { }
